import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './container.module.css';
export const Container = forwardRef(({ as: Component = 'div', children, className, dimension = 'full', padding = true, ...otherProps }, forwardedRef) => (_jsx(Component, { ref: forwardedRef, className: clsx(styles.Container, className), "data-container-dimension": dimension, "data-container-padding": padding, ...otherProps, children: children })));
